<template>
  <div>
    <el-row>
      <div class="model-header">
        <h2>Xem tin tức: {{ modelData.title }}</h2>
        <el-button @click="backModel" size="small" class="btn-back">Trờ về</el-button>
      </div>
    </el-row>
    <el-row>
      <div class="model-content">
        <el-col :span="20">
          <el-form label-position="top" :model="modelData" ref="createModel">
            <el-form-item prop="image" label="Ảnh bìa tin tức">
              <img v-if="modelData.image_path" :src="modelData.image_path" class="blogs">
            </el-form-item>
            <el-form-item prop="category_id" label="Danh mục tin tức" class="form-item">
              <span>{{ modelData.category_text }}</span>
            </el-form-item>
            <el-form-item prop="title" label="Tiêu đề tin tức" class="form-item">
              <span>{{ modelData.title }}</span>
            </el-form-item>
            <el-form-item prop="description" label="Mô tả ngắn" class="form-item">
              <span>{{ modelData.description }}</span>
            </el-form-item>
            <el-form-item prop="content" label="Nội dung tin tức">
              <div v-html="modelData.content"></div>
            </el-form-item>
            <el-form-item label="Kích hoạt" prop="status">
              <el-switch
                active-color="#13ce66"
                inactive-color="#7f8c8d"
                disabled
                v-model="modelData.status">
              </el-switch>
            </el-form-item>
          </el-form>
        </el-col>
      </div>
    </el-row>
  </div>
</template>

<script>
import axios from 'axios'
import { mapActions } from 'vuex'
export default {
  name: 'BlogShow',
  metaInfo () {
    return {
      title: 'Tin tức | Xem chi tiết'
    }
  },
  components: {

  },
  data () {
    return {
      canSubmit: true,
      modelData: {
        category_id: '',
        title: '',
        description: '',
        image: '',
        image_path: '',
        content: '',
        status: true
      },
      lists: {

      }
    }
  },
  mounted () {
    this.configBreadcrumb()
    this.fetchModel()
  },
  methods: {
    handleImageAdded: async function (file, success, failure) {
      let formData = new FormData()
      formData.append('file', file.blob())
      let response = await axios.post('blogs/upload', formData)
      if (response.code === 1) {
        success(response.data.path)
      } else {
        return false
      }
    },
    // Lấy action từ Vuex
    ...mapActions(['setBreadcrumb']),
    // Cấu hình Breadcrumb
    configBreadcrumb () {
      let breadcrumb = [
        { name: 'home-index', text: 'Trang chủ' },
        { name: 'blogs-index', text: 'Tin tức' },
        { name: 'blogs-create', text: 'Xem chi tiết' }
      ]

      this.setBreadcrumb(breadcrumb)
    },
    // Nút back lại trang Index
    backModel () {
      this.$router.push({name: 'blogs-index'})
    },
    // Tải dữ liệu Model xuống
    fetchModel () {
      this.canSubmit = false
      axios.get('blogs/' + this.$route.params.id).then(response => {
        switch (response.code) {
          case 200:
            this.canSubmit = true
            this.modelData = response.data
            break
          default:
            this.$notify.error({
              title: 'Error',
              message: 'Đã có lỗi xảy ra. Vui lòng liên hệ Admin !'
            })
            break
        }
      })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style type="text/css" scoped>
.model-content {
  padding-top: 15px;
}
.blogs {
  width: 840px;
  height: 300px;
  display: block;
  object-fit: cover;
}
</style>

<style type="text/css">
.blogs-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.blogs-uploader .el-upload:hover {
  border-color: #409EFF;
}
.blogs-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 840px;
  height: 300px;
  line-height: 300px !important;
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/components/blogs/Show.vue